// postits.ts — Endpoints post-its (mémo personnel par utilisateur).
// Ownership géré par la session côté serveur.
import { req } from './_internals.js';

export const postitsApi = {
  getPostits: () => req('GET', '/postits'),
  createPostit: (d: unknown) => req('POST', '/postits', d),
  updatePostit: (id: number | string, d: unknown) => req('PUT', '/postits/' + id, d),
  deletePostit: (id: number | string) => req('DELETE', '/postits/' + id),
  deleteAllPostits: () => req('DELETE', '/postits'),
  reorderPostits: (order: unknown) => req('PUT', '/postits/reorder', order),
};
